<style lang="css">
/* src/components/YourComponent.vue */
@import './assets/css/style.css';

/* Your component-specific styles go here */
</style>

<template>
    <nav class="container flex pt-4 md:pt-14 z-50">
        <MainHeadingNav/>
    </nav>
    

    <HomeHero/>
    
    <router-view></router-view>
    
    <Footer/>
    
  </template>



<script>
// import { gsap } from 'gsap'

import MainHeadingNav from './components/global/MainHeadingNav.vue'
import Footer from './components/global/FooterNav.vue'
// import HomeHero from './components/home/HomeHero.vue'



export default {
  name: 'App',
  components: {
      MainHeadingNav,
    //   HomeHero,
      Footer,
  },
//   mounted() {
//     // Use GSAP to animate the element with a 1-second duration and slide it to the right
//     gsap.to(this.$refs.myElement, { duration: 1, x: 100 });
//   }
}
</script>

<style>

</style>
